import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dde4ceb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tw-overflow-hidden"
}
const _hoisted_2 = {
  key: 0,
  class: "tw-pb-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeSpellingRuleCategoryTree = _resolveComponent("HomeSpellingRuleCategoryTree", true)!

  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        href: "",
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openCategory && _ctx.openCategory(...args)), ["prevent"])),
        class: _normalizeClass([{ 'main-cat': _ctx.isMainCategory }, "tw-text-mainbg1 hover:tw-text-mainbg1 tw-no-underline [&:has(+)]:bg-red-500"])
      }, _toDisplayString(_ctx.category.spellingRuleName), 3)
    ]),
    _createVNode(_Transition, { name: "scale" }, {
      default: _withCtx(() => [
        (_ctx.hasSubCategories && _ctx.expanded)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.category.subCategories, (c) => {
                return (_openBlock(), _createBlock(_component_HomeSpellingRuleCategoryTree, {
                  category: c,
                  level: _ctx.level + 1,
                  key: c.id,
                  "expanded-id": _ctx.innerExpandedId,
                  onExpand: ($event: any) => (_ctx.toggleExpanded(c.id)),
                  class: "subcat tw-text-lg tw-text-left tw-font-normal tw-pl-8"
                }, null, 8, ["category", "level", "expanded-id", "onExpand"]))
              }), 128)),
              (_ctx.level == 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}